export default class OmeTiffSource {
    constructor({ url, requestInit }) {
        this.url = url;
        this.requestInit = requestInit;
    }
}
//# sourceMappingURL=OmeTiffSource.js.map